(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.h5utils = {}));
}(this, function (exports) { 'use strict';

  function isMobileSafari() {
    var ua = navigator.userAgent;
    var isIos = / OS \d/.test(ua);
    var notChrome = !~ua.indexOf('CriOS');
    var notMozilla = !ua.indexOf('Mozilla');
    var isSafari = /Safari\/[\d\.]+$/.test(ua);
    return isIos && notChrome && notMozilla && isSafari;
  }

  var getBrowserVersion = function getBrowserVersion() {
    var ua = navigator.userAgent;
    return {
      baiduspider: /Baiduspider/.test(ua),
      QQLive: /QQLive/i.test(ua),
      mqq: /QQ\/([\d\.]+)/i.test(ua), //是否为手机QQ
      weibo: /Weibo/i.test(ua), //是否为微博
      MicroMessenger: /MicroMessenger/i.test(ua), //是否为微信
      mbaidu: /baiduboxapp/i.test(ua), //是否为手机百度
      iqiyi: /iqiyi/i.test(ua),
      qq: /MQQBrowser/i.test(ua), //是否为QQ浏览器
      mobile: /AppleWebKit.*Mobile.*/i.test(ua), //是否为移动终端
      uc: /UCBrowser/i.test(ua), //是否为UC
      xiaomiqjs: /MiuiQuickSearchBox/.test(ua),
      dianping: /dianping/.test(ua),
      ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua), //ios终端
      android: /Android/i.test(ua) || /Linux/i.test(ua), //android终端或者uc浏览器
      windowsphone: /Windows Phone/i.test(ua), //Windows Phone
      iPhone: /iPhone/i.test(ua), //是否为iPhone或者QQHD浏览器
      iPad: /iPad/i.test(ua), //是否iPad
      webApp: !/Safari/i.test(ua), //是否web应该程序，没有头部与底部
      baidu: /Baidu/i.test(ua), //是否为百度浏览器
      Safari: isMobileSafari(),
      Youku: /youku/i.test(ua),
      chrome: /CriOS/i.test(ua),
      CMDC: /CMDC/i.test(ua),
      BiliApp: /BiliApp/i.test(ua)
    };
  };

  var setCookie = function setCookie(name, value) {
    var exp = new Date();
    exp.setTime(exp.getTime() + 5 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";domain=.bilibili.com;path=/";
  };

  var getCookie = function getCookie(name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    }
    return null;
  };

  var getURLlist = function getURLlist(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  };

  var setParam = function setParam(param, value) {
    var query = location.search.substring(1);
    var p = new RegExp("(^|&" + param + ")=[^&]*");
    if (p.test(query)) {
      query = query.replace(p, "$1=" + value);
      return '?' + query;
    } else {
      if (query == '') {
        return '?' + param + '=' + value;
      } else {
        return '?' + query + '&' + param + '=' + value;
      }
    }
  };

  var changeURLform = function changeURLform() {
    var browser = getBrowserVersion();
    var v = void 0;
    if (browser.iqiyi) {
      v = 'iqiyi_video_app';
    } else if (browser.weibo) {
      v = 'weibo';
    } else if (browser.QQLive) {
      v = 'QQLive';
    }

    if (v) {
      if (!getURLlist('bsource')) {
        var m = setParam('bsource', v.toLowerCase());
        if (window.history && history.replaceState) {
          history.replaceState(null, null, '//' + location.host + location.pathname + m + location.hash);
        }
      }
    }
  };

  var identify = function identify() {
    var bsource;
    var result = getURLlist('bsource') ? getURLlist('bsource').toLowerCase() : '';
    if (result) {
      bsource = result;
    } else if (document.referrer && /(.)*((baike.so.com)|(m.so.com)|(m.image.so.com)|(m.video.so.com)|(www.so.com)|(\.baidu.com)|(\.google.com)|(\.sm.cn)|(m.soso.com)|(www.soso.com)|(\.sogou.com)|(\.bing.com))/.test(document.referrer)) {
      var refer = document.referrer;
      if (/(.)*((baike.so.com)|(m.image.so.com)|(m.so.com)|(m.video.so.com)|(www.so.com))/.test(refer)) {
        bsource = 'seo_360';
      } else if (/(.)*\.baidu.com/.test(refer)) {
        bsource = 'seo_baidu';
      } else if (/(.)*\.google.com/.test(refer)) {
        bsource = 'seo_google';
      } else if (/(.)*\.sm.cn/.test(refer)) {
        bsource = 'seo_sm';
      } else if (/(.)*((m.soso.com)|(www.soso.com)|(\.sogou.com))/.test(refer)) {
        bsource = 'seo_sougo';
      } else if (/(.)*\.bing.com/.test(refer)) {
        bsource = 'seo_bing';
      }
    } else if (!getCookie('bsource')) {
      var browser = getBrowserVersion();
      var bsourceMap = {
        baiduspider: 'baiduspider',
        QQLive: 'qqlive',
        mqq: 'qq',
        weibo: 'weibo',
        MicroMessenger: 'wechat',
        mbaidu: 'bdbox',
        iqiyi: 'iqiyi_video_app',
        qq: 'qqbrowser_app',
        uc: 'uc_browser_app',
        xiaomiqjs: 'xiaomiqjs',
        dianping: 'dianping'
      };
      for (var k in bsourceMap) {
        if (browser[k]) {
          bsource = bsourceMap[k];
          break;
        }
      }
    } else {
      bsource = getCookie('bsource');
    }
    return bsource;
  };

  var canLocateToMiddlePage = function canLocateToMiddlePage() {
    var browser = getBrowserVersion();
    var regStr_saf = /os [\d._]*/gi;
    var verinfo = navigator.appVersion.match(regStr_saf);
    if (verinfo) {
      verinfo = verinfo.join(',').replace(/[^0-9|_.]/ig, '');
      verinfo = verinfo.replace(/_[0-9]*/ig, '');
    }
    if (verinfo && Number(verinfo) >= 9 && !browser.qq) {
      return true;
    }
    return false;
  };

  var customReport = function customReport(name, ops) {
    if (window.reportConfig && window[reportConfig['msgObjects']]) {
      var reportObj = window[reportConfig['msgObjects']];
      var obj = ops ? ops : name;
      reportObj[name] = obj;
    }
    if (window.reportObserver) {
      window.reportObserver.forceCommit();
    }
  };

  var ajax = function ajax(url, callback) {
    var req = new XMLHttpRequest();
    req.onreadystatechange = function (e) {
      if (this.readyState === 4 && this.status === 200) {
        var data = JSON.parse(this.response);
        callback(data);
      }
    };
    req.onerror = function () {};
    req.ontimeout = function () {};
    req.open("GET", url);
    req.send();
  };

  function getDownloadLink(schema, directDownload, delayDownload) {
    var browser = getBrowserVersion();
    if (browser.MicroMessenger) {
      if (window.bsource === 'app_bili') {
        return '//a.app.qq.com/o/simple.jsp?pkgname=tv.danmaku.bili&ckey=CK1389719810898';
      } else if (browser.android) {
        return '//a.app.qq.com/o/simple.jsp?pkgname=tv.danmaku.bili&ckey=CK1385399615180&android_schema=' + encodeURIComponent(schema);
      } else {
        return '//a.app.qq.com/o/simple.jsp?pkgname=tv.danmaku.bili&ckey=CK1385399615180';
      }
    }

    if (browser.android) {
      var href = '//dl.hdslb.com/mobile/latest/iBiliPlayer-bilih5.apk';
      if (window.isOverSea) {
        href = 'https://dl.hdslb.com/mobile/upload/iBiliPlayer-internation-default.apk';
      }
      if (window.bsource === 'bdts') {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_bdts.apk';
      }
      if (window.bsource === 'baidu_aladdin') {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_baidu_aladdin.apk';
      }
      // 微博源
      if (browser.weibo || window.WeiboJSBridge || window.WebViewJavascriptBridge || window.__WeiboJSBridge) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_weibo.apk';
      }
      // 百度源
      if (browser.baidu || window.bd_searchbox_interface || window.bdbox_android_common) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_bdbox.apk';
      }
      // uc源
      if ((browser.uc || window.ucbrowser || window.ucapi) && document.referrer && document.referrer.indexOf('tv.uc.cn') >= 0) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_uc_video.apk';
      }
      // 腾讯视频
      if (window.bsource === 'QQLive' || window.bsource === 'qqlive') {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_qqlive.apk';
      }
      if (window.bsource) {
        var isSeo = window.bsource.indexOf('seo') >= 0;
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_' + (isSeo ? 'seo' : encodeURIComponent(window.bsource)) + '.apk';
      }
      if (!directDownload && !delayDownload) {
        href = 'http://d.bilibili.com/download_app.html?download_url=' + encodeURIComponent(href) + '&schema=' + encodeURIComponent(schema);
      }
      return href;
    }

    if (browser.ios) {
      var _href = 'https://itunes.apple.com/cn/app/bi-li-bi-li-dong-hua/id736536022';
      if (browser.weibo || browser.chrome) {
        _href = 'https://itunes.apple.com/cn/app/id736536022?mt=8#id1047562725';
      }
      if (!directDownload) {
        return 'http://d.bilibili.com/download_app.html?download_url=' + encodeURIComponent(_href) + '&schema=' + encodeURIComponent(schema);
      }
      return _href;
    }

    if (browser.windowsphone) {
      return 'https://www.windowsphone.com/zh-cn/store/purchase/validate?app=75620dee-4a7a-4dae-8677-0d930e05f57e&apptype=regular&offer=3869edb1-e34c-469a-af6e-2c8a7856cb61';
    }
  }

  function openAppLink(redirectLink, downloadLink, autoDownload, delayDownload) {
    if (!redirectLink || !downloadLink) {
      return;
    }
    if (delayDownload) {
      if (autoDownload) {
        setTimeout(function () {
          if (!document.hidden) {
            location.href = downloadLink;
          }
        }, 2000);
      }
      location.href = redirectLink;
    } else {
      if (autoDownload) {
        setTimeout(function () {
          location.href = downloadLink;
        }, 500);
      }
      location.href = redirectLink;
    }
  }

  var openApp = function openApp(options) {
    options = options || {};
    var _options = options,
        schema = _options.schema,
        universalLink = _options.universalLink,
        autoDownload = _options.autoDownload,
        onlySchema = _options.onlySchema,
        directDownload = _options.directDownload,
        delayDownload = _options.delayDownload,
        downloadUrl = _options.downloadUrl,
        extra = _options.extra;

    if (typeof autoDownload === 'undefined') {
      autoDownload = true;
    }
    extra = extra || '';
    schema = schema || 'bilibili://rank/rank';
    universalLink = universalLink || 'http://m.bilibili.com/index.html';
    var browser = getBrowserVersion();
    if (browser.BiliApp) {
      location.href = schema;
      return;
    }
    var downloadLink = downloadUrl || getDownloadLink(schema, directDownload, delayDownload);
    if (downloadLink.indexOf('.apk') > 0 || downloadLink.indexOf('d.bilibili.com') > 0 || downloadLink.indexOf('app.qq.com') > 0) {
      customReport('request_download', 1);
    }

    if (browser.android && browser.MicroMessenger) {
      location.href = downloadLink;
      return;
    }

    var isAndroidWeibo = browser.android && browser.weibo;
    var isIosQQ = browser.ios && browser.qq;
    if ((isAndroidWeibo || isIosQQ) && !onlySchema && !directDownload) {
      location.href = 'http://d.bilibili.com/download_app.html?preUrl=' + encodeURIComponent(universalLink) + '&schema=' + encodeURIComponent(schema) + '&from=android-weibo&' + extra;
      return;
    }

    if (browser.ios && canLocateToMiddlePage() && !onlySchema && !directDownload) {
      location.href = 'http://d.bilibili.com/download_app.html?preUrl=' + encodeURIComponent(universalLink) + '&schema=' + encodeURIComponent(schema) + '&' + extra;
      return;
    }

    var realSchema = schema.indexOf('?') > 0 ? schema + '&' + extra : schema + '?' + extra;

    openAppLink(realSchema, downloadLink, autoDownload, delayDownload);
  };

  var judgeOverSea = function judgeOverSea() {
    ajax('//api.bilibili.com/x/web-interface/zone?jsonp=jsonp', function (data) {
      if (data.code === 0 && data.data && data.data.country && data.data.country !== '中国') {
        window.isOverSea = true;
      }
    });
  };

  var init = function init(options) {
    options = options || {};
    var _options2 = options,
        changeURL = _options2.changeURL;

    if (!window.bsource) {
      window.bsource = identify();
      if (window.bsource) {
        setCookie('bsource', window.bsource);
      }
    }
    if (options.changeURL) {
      changeURLform();
    }
  };

  exports.init = init;
  exports.judgeOverSea = judgeOverSea;
  exports.openApp = openApp;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
